// tslint:disable:max-line-length
export default {
  addListingForm: {
    market: "Squarefoot",
    mobileStepMark: "Step {currentStep} of {allSteps}.",
    finalStepPrompt: "Review listing steps",
    step: "Step",
    qualityStep: "QUALITY STEP",
    title: "Start listing your property",
    description:
      "Please ensure you fill out all required information(*) to best represent your property.",
    tips: "Vestibulum ante ipsum primis in faucibus orci luctus etultrices pousuere cubilia Curae; Donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula Praesent sapien massa, convallis a pellentesquenec, egestas non nisi.",
    step3: {
      title: "Tell us more about the property.",
      fieldset: {
        price: "Property price",
        size: "Size details",
        format: "Property Details",
        configuration: "Property configuration",
        other: "Other property details",
      },
      buttons: {
        apply: "Apply",
      },
    },

    facilitiesFeatures: {
      title: "What facilities does the property have?",
      fields: {
        hideMoreLabel: "Hide more options",
        showMoreLabel: "View more options",
      },
      facility: {
        label: "Estate / Building facilities",
      },
      feature: {
        label: "Property facilities",
      },
    },
    stepOfDescription: {
      requirements: {
        text: "Character requirements",
      },
    },
    upgrade: {
      title: "Upgrade your listing",
      description:
        "All properties are published as a Standard for 90 days. To rank higher in the search results and appear on site longer, you can also add an upgrade below:",
      tips: "Only listings that meet the quality gate will rank and rotate at the top of each tier. All other listings will rank and rotate beneath these listings.",
      placeholder: "Please select a contract",
      select: {
        description:
          "Select which contract you want the upgrade allocated from",
        agent: "My contract",
        branch: "Branch contract",
        agency: "Agency contract",
      },
      edit: {
        tip: "Your current tier",
        upgraded: "Upgraded on:",
        expires: "Expires in:",
        rotation: "Next rotation:",
      },
      active: "Current upgrade",
      duration:
        "{productDuration} day {noStandard, plural, =1 {+ 90 day Standard} other {}}",
      noDuration: "30 - 45 day options",
      noRemainingTip: "Contact your account manager for details.",
      remaining: "{remaining} remaining",
      highestUpgrade: "HIGHEST UPGRADE",
      otherInfo: {
        duration: "Duration:",
        remaining: "Upgrades available:",
      },
      note: "Note: This is a paid upgrade. Please speak with your office admin for authority to use.",
      tab: {
        rent: "RENT",
        sale: "BUY",
      },
      formatError: {
        title: "You only have 1 {upgrade} to use.",
        message: "Please review your selection before proceeding.",
      },
      requiredError: {
        title: "You still need to make a selection for rent.",
        message:
          "Please select the rent tab and choose an upgrade or standard listing to continue.",
      },
      permissionError: {
        title: "Sorry but you are unable to see the details on this step.",
        message:
          "You may not have permission, or the listing ID you're looking for may be wrong incorrect.",
      },
      modal: {
        title: "Your upgrade selection will not be saved if you exit.",
        content: "Continue to publish to use your selected upgrade.",
        buttons: {
          confirm: "Continue to publish",
          cancel: "Save and exit",
        },
        confirmation: {
          content:
            "The selected contract does not apply to the secondary agent selected in step 1. Proceed to remove secondary agent or cancel to select another contract.",
          button: {
            cancel: "Cancel",
            confirm: "Yes, proceed",
          },
        },
      },
    },
    reActivate: {
      modal: {
        title: "Are you sure you want to reactivate?",
        content:
          "This listing has been flagged with issues. Please contact your account manager to find out more.<br/><br/>Please note, if you choose to reactivate this property, it will be treated as a new listing.",
        button: {
          confirm: "Yes, reactivate",
        },
      },
    },
    stepOfPublish: {
      title: "Confirm and Publish",
      description: "Your listing is now ready to publish.",
      permissionWarning: {
        title: "You are unable to publish this listing",
        message:
          "You are permitted to edit only. You do not have permission to publish.",
      },
    },
    media: {
      title: "Add media to your listing",
      description:
        "Ensure your photos are high quality and represent your property well. ",
      requirements: {
        text: "View upload requirements",
        description:
          "When uploading your photos and floor plans make sure they meet the below requirements:",
        rules: {
          rule0:
            "Cover photo supplied as landscape with a minimum resolution of 800 x 600px",
          rule1: "Maximum file size is 20MB",
          rule2: "Accepted file formats are JPEG, PNG, HEIC",
          rule3: "No duplicate or Illicit/unlawful photos",
          rule4: "No logos other than your agency's own logo on photos",
          rule5: "No phone numbers or email addresses on photos",
        },
        note: "<strong>Note: </strong>To advertise on Premium requires minimum of 5 photos",
      },
      tips: "Vestibulum ante ipsum primis in faucibus orci luctus etultrices pousuere cubilia Curae; Donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula Praesent sapien massa, convallis a pellentesquenec, egestas non nisi.",
      qualityNote:
        "Listing quality: Incomplete! Review now and complete to rank higher 	",
      fieldset: {
        images: "Images",
        floorPlans: "Floor plans",
        videos: "Video",
        image360s: "360 Video",
      },
      uploadMsg: {
        popupTitle: "You are trying to upload too many photos",
        max: "You are permitted a maximum of  {limit} photos. Please choose the photos you want to upload again.",
        button: {
          cancel: "Cancel",
          ok: "Choose photos",
        },
      },
      cover: {
        text: "Cover Photo",
        label: "Select as cover photo",
        sizeWarning:
          "The chosen cover photo is not the optimal size. Please select a landscape photo (min 800 x 600px) to represent your property best.",
      },
      buttons: {
        remove: "Delete?",
        crop: "Crop",
        rotate: "Rotate",
        save: "Save edited photo",
        save360: "Save edited image",
        retry: "RETRY",
        cancel: "Cancel",
      },
      caption: "Add a caption...",
      uploadErrors: {
        msg: "{num} {num, plural, =1 {photo} other {photos}} failed to upload",
        viewBtn: {
          images: "View details",
          floorPlans: "View floor plans",
        },
        title: "Your photos didn't upload.",
        description:
          "Please supply photos with 20MB max file size, and as a JPEG, PNG or HEIC format.",
        button: "Dismiss photos",
        errors:
          "Invalid {format, plural, =1 {<span>file format</span>} other {}}{size, plural, =1 {<span>file size</span>} other {}}{resolution, plural, =1 {<span>file resolution</span>} other {}}{notA360Photo, plural, =1 {<span>image, image is not a supported 360 image format</span>} other {}}",
      },
    },
    success: {
      tips: "All done!",
      description: "Your listing is now published.",
      back: "Back to all listings",
      createAnother: "Create another listing",
    },
  },
};
